/* This file is autogenerated, see readme.md for instructions */
import ArrowRightSvgIcon from '@bloomreach/banana-theme/icons/arrow-right.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ArrowRightIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ArrowRightSvgIcon />
    </Icon>
  );
});

ArrowRightIcon.displayName = 'ArrowRightIcon';

export default ArrowRightIcon;
